import React, { Component } from 'react';
import styled from 'styled-components';
import { AUTH_TOKEN_BG, XHT_WHITE } from '../../config/media';

const Wrapper = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	text-align: center;
	.bg-wrapper-text {
		position: absolute;
		top: 50%;
		left: 0;
		right: 0;
		transform: translate(0, -50%);
		color: #fff;
		h2 {
			font-size: 32px;
			color: #fff;
			font-weight: bold;
		}
		p {
			font-size: 14px;
			line-height: 16px;
		}
		.btn-link {
			color: #fff;
			font-size: 10px;
			padding: 7px 14px;
			border: 2px solid #fff;
			text-decoration: none;
			font-weight: bold;
		}
	}
	.bg-wrapper-image {
		width: 100%;
		height: 100%;
		background-position: center;
		background-size: cover;
		background-image: url(${AUTH_TOKEN_BG});
	}
	.xht-icon {
		height: 84px;
	}
	@media (max-width: 1200px) {
		.bg-wrapper-text {
			width: 650px;
			left: 30px;
			h2 {
				font-size: 20px;
			}
			p {
				font-size: 12px;
			}
		}
	}
`;

class Token extends Component {
	render() {
		return (
			<Wrapper>
				<div className="bg-wrapper-image"></div>
				<div className="bg-wrapper-text">
					<img src={XHT_WHITE} alt="XHT" className="xht-icon" />
					<h2>HollaEx Token — Fuel for Exchanges</h2>
					<p>
						HollaEx Token (XHT) powers the HollaEx exchange software kit.
						<br />
						Future-proof your exchange today with the HollaEx Token.
					</p>
					<a
						href="https://pro.hollaex.com/trade/xht-usdt"
						title="hollaex"
						target="_blank"
						rel="noopener noreferrer"
						className="btn-link"
					>
						Get HollaEx Token
					</a>
				</div>
			</Wrapper>
		);
	}
}

export default Token;
